<template>
  <div>
        <div class="panel panel-default">
            <div class="panel-heading">
                <div>
                    <span>
                        Assigned Team Members
                    </span>
                </div>
            </div>
            <div class="panel-body">
                <assigned-team-members></assigned-team-members>
            </div>
            <div class="panel-footer">
                <button class="btn btn-default" name="button" @click="showManageTeamMembersForm"><span class="fa fa-users"></span> Manage Team Members</button>
            </div>
        </div>

        <div class="modal fade" id="modal-manage-team-members" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            Manage Team Members
                        </h4>
                    </div>
                    <div class="modal-body">
                        <manage-team-members-form></manage-team-members-form>
                    </div>
                      <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import AssignedTeamMembers from './AssignedTeamMembers.vue';
import ManageTeamMembersForm from './ManageTeamMembersForm.vue';

export default {
    components: {
        AssignedTeamMembers,
        ManageTeamMembersForm,
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        })
    },

    created() {},

    methods: {
        showManageTeamMembersForm() {
            $('#modal-manage-team-members').modal('show');
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/AssignedTeamMembersView.vue